import type { CreatorEntity as Entity } from "shared/schema";
import { EntityBackgroundHeader } from "./EntityBackgroundHeader.js";
import { EntityButton } from "./EntityButton.js";
import { EntityNavigation } from "./EntityNavigation.js";

export function EntityHeader({ entity, children }: { entity: Entity; children: React.ReactNode }): React.ReactElement {
	return (
		<EntityBackgroundHeader entity={entity} mods="pad-none">
			<section className="pad-3x space-none width-wide">
				<div className="space-none">{children}</div>
				<EntityButton entity={entity} mods="size-small pin-left pin-bottom" />
			</section>
			<EntityNavigation entity={entity} />
		</EntityBackgroundHeader>
	);
}
